export enum BillSource {
    Intern,
    Vitroconnect,
    Authphone
}